<template>
  <div class='mi-swiper-slide' @click="clickSlide">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "mi-swiper-slide",
  methods: {
    clickSlide() {
      this.$emit('click');
    },
  },
};
</script>